// Accordion
(function () {
    const accordions = document.querySelectorAll(`.accordion`);

    accordions.forEach((accordion) => {
        const toggleButton = accordion.querySelector(`.js-accordion-button`);
        const showAllButton = accordion.querySelector(`.js-show-all`);
        const accordionOuter = accordion.querySelector(`.accordion__outer`);
        const accordionInner = accordion.querySelector(`.accordion__inner`);

        const updateHeight = () => {
            accordionOuter.style.maxHeight = `${accordionInner.offsetHeight}px`;
        };

        toggleButton?.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            if (accordion.classList.contains(`accordion--active`)) {
                accordion.classList.remove(`accordion--active`);
                accordionOuter.style.maxHeight = `0`;
            } else {
                accordion.classList.add(`accordion--active`);
                updateHeight();
            }
        });

        window.addEventListener(`resize`, () => {
            if (accordion.classList.contains(`accordion--active`)) {
                updateHeight();
            }
        });

        if (accordion.classList.contains(`accordion--active`)) {
            window.addEventListener(`load`, updateHeight);
        }

        if (showAllButton) {
            const buttonDefaultText = showAllButton.textContent;
            const buttonAlternativeText = showAllButton.dataset.text;

            showAllButton.addEventListener(`click`, (evt) => {
                evt.preventDefault();

                if (accordion.classList.contains(`accordion--visible`)) {
                    showAllButton.textContent = buttonDefaultText;
                    accordion.classList.remove(`accordion--visible`);
                    updateHeight();

                    accordion.scrollIntoView({block: `end`, behavior: `smooth`});
                } else {
                    showAllButton.textContent = buttonAlternativeText;
                    accordion.classList.add(`accordion--visible`);
                    updateHeight();
                }
            });
        }
    });
})();